import { IconWrapper } from '../runtime';
export default IconWrapper('members-shape', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("g", [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.1781 12.6749C14.7327 12.3764 15.1111 11.7829 15.1111 11.0987V4.89821C15.1111 4.29308 14.8148 3.75908 14.3626 3.42792L9.05044 0.360646C8.75801 0.135279 8.39491 0 8.00003 0C7.60514 0 7.24204 0.135279 6.91159 0.360646L1.89855 3.28834C1.36304 3.54334 0.975701 4.06594 0.891819 4.6884L0.888916 11.0966C0.888916 11.8563 1.35564 12.503 2.01175 12.7846L6.94424 15.6352C7.23769 15.8631 7.60268 16 8.00003 16C8.39738 16 8.76237 15.8631 9.08919 15.6352L14.1781 12.6749Z",
      "fill": "#F1A100"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.60153 4.17025C7.94353 3.98798 8.39845 4.12217 8.57769 4.46997L9.63165 6.57795L11.7627 6.06802C11.9087 6.03309 12.0618 6.04682 12.1996 6.1072C12.5541 6.26263 12.7177 6.68096 12.5648 7.04155L10.9842 10.7704C10.8737 11.0311 10.6213 11.2 10.3422 11.2H5.51323C5.22555 11.2 4.96724 11.0208 4.86228 10.7484L3.42588 7.02091C3.37294 6.88353 3.36335 6.7328 3.39843 6.58962C3.49178 6.2086 3.87118 5.97668 4.24586 6.07161L6.22322 6.57261L7.3068 4.46997C7.37279 4.34191 7.4756 4.23736 7.60153 4.17025ZM6.29561 7.69586L4.80005 7.32033L5.82476 9.95563H10.0704L11.2 7.31455L9.57768 7.69929C9.26774 7.77279 8.94774 7.62548 8.79994 7.34125L8.00005 5.68896L7.08222 7.33998C6.93284 7.62724 6.60787 7.77427 6.29561 7.69586Z",
      "fill": "white"
    }
  })])]);
});